/**
 * fotaRemoteUpManagement 模块英文映射
 * 中文原文做 key，value 为英文译文；由 src/i18n/index.js 自动合并
 */
export default {
  'IMEI号': 'IMEI No.',
  'sim卡号': 'SIM Card No.',
  '发送时间': 'Send Time',
  '请输入备注': 'Please enter remark',
  'FOTA命令查询': 'FOTA Command Query',
  'fota参数': 'FOTA Parameters',
  'fota批量升级': 'FOTA Batch Upgrade',
  'imei号': 'IMEI No.',
  '上一步': 'Previous',
  '下一步': 'Next',
  '任务名称': 'Task Name',
  '使用状态': 'Usage Status',
  '信息': 'Notice',
  '元': 'CNY',
  '共{total}条': 'Total {total} records',
  '关闭': 'Close',
  '其他': 'Other',
  '分': 'min',
  '分钟': 'min',
  '创建人': 'Created By',
  '创建时间': 'Created At',
  '删除': 'Delete',
  '刷新': 'Refresh',
  '升级中': 'Upgrading',
  '升级信息': 'Upgrade Info',
  '升级包信息': 'Upgrade Package Info',
  '升级包选择': 'Upgrade Package Selection',
  '升级失败': 'Upgrade Failed',
  '升级成功': 'Upgrade Successful',
  '升级方案名称': 'Upgrade Plan Name',
  '升级日志': 'Upgrade Log',
  '升级状态': 'Upgrade Status',
  '发送失败': 'Send Failed',
  '发送成功': 'Send Successful',
  '取消': 'Cancel',
  '取消升级': 'Upgrade Cancelled',
  '取消升级成功': 'Upgrade cancelled successfully',
  '取消命令': 'Command Cancelled',
  '取消选择': 'Deselect',
  '否': 'No',
  '周': 'Week',
  '命令内容': 'Command Content',
  '命令参数': 'Command Parameters',
  '命令详情': 'Command Details',
  '固件导入': 'Firmware Import',
  '备注': 'Remark',
  '天': 'Day',
  '完成': 'Finish',
  '导出': 'Export',
  '导出文件': 'Export File',
  '展开': 'Expand',
  '差分文件': 'Difference File',
  '差分文件中的信息和方案中的信息不一致，请确认后重新输入！': 'The difference file info does not match the plan info. Please verify and re-enter!',
  '差分文件命名不正确': 'Incorrect difference file naming',
  '已发送': 'Sent',
  '已建档': 'Filed',
  '已选择 {count} 项': '{count} items selected',
  '年': 'Year',
  '开始时间': 'Start Time',
  '当前选择：': 'Currently selected:',
  '待升级': 'Pending Upgrade',
  '批量操作': 'Batch Operations',
  '折叠': 'Collapse',
  '接收内容': 'Received Content',
  '接收时间': 'Received At',
  '描述': 'Description',
  '提示': 'Notice',
  '操作': 'Action',
  '收起': 'Collapse',
  '故障': 'Fault',
  '文件大小:': 'File size:',
  '新固件信息': 'New Firmware Info',
  '新固件名称': 'New Firmware Name',
  '新固件型号': 'New Firmware Model',
  '新固件字节数': 'New Firmware Byte Count',
  '新固件文件': 'New Firmware File',
  '新固件版本': 'New Firmware Version',
  '新固件版本号': 'New Firmware Version',
  '新增': 'Add',
  '方案信息': 'Plan Info',
  '方案名称': 'Plan Name',
  '无': 'None',
  '日': 'Day',
  '旧固件信息': 'Old Firmware Info',
  '旧固件名称': 'Old Firmware Name',
  '旧固件型号': 'Old Firmware Model',
  '旧固件字节数': 'Old Firmware Byte Count',
  '旧固件文件': 'Old Firmware File',
  '旧固件版本': 'Old Firmware Version',
  '旧固件版本号': 'Old Firmware Version',
  '时': 'h',
  '是': 'Yes',
  '是否带阀门': 'With Valve',
  '暖通阀': 'HVAC Valve',
  '更多': 'More',
  '月': 'Month',
  '有': 'Yes',
  '未发送': 'Not Sent',
  '未建档': 'Not Filed',
  '未知': 'Unknown',
  '查询': 'Query',
  '查询结束时间': 'End time',
  '查询起始时间': 'Start time',
  '次': 'times',
  '正常': 'Normal',
  '正确': 'Correct',
  '水表用途': 'Water Meter Purpose',
  '添加成功': 'Added successfully',
  '清空': 'Clear',
  '状态': 'Status',
  '确定': 'OK',
  '确定删除吗?': 'Are you sure you want to delete?',
  '确定取消升级吗?': 'Are you sure you want to cancel the upgrade?',
  '秒': 's',
  '编辑': 'Edit',
  '老固件版本号': 'Old Firmware Version',
  '表口径': 'Meter Caliber',
  '表号': 'Meter No.',
  '表类型': 'Meter Type',
  '表编号': 'Meter No.',
  '设备信息': 'Device Info',
  '该方案名称已存在，请重新输入!': 'This plan name already exists, please re-enter!',
  '详情': 'Details',
  '请先导入差分文件': 'Please import the difference file first',
  '请输入fota升级方案名称': 'Enter FOTA upgrade plan name',
  '请输入fota参数内容': 'Enter FOTA parameter content',
  '请输入imei号': 'Enter IMEI no.',
  '请输入任务名称': 'Please enter task name',
  '请输入升级方案名称': 'Enter upgrade plan name',
  '请输入升级表号': 'Enter meter no. to upgrade',
  '请输入新固件型号': 'Enter new firmware model',
  '请输入新固件字节数': 'Enter new firmware byte count',
  '请输入新固件版本': 'Enter new firmware version',
  '请输入新固件版本号': 'Enter new firmware version',
  '请输入旧固件型号': 'Enter old firmware model',
  '请输入旧固件字节数': 'Enter old firmware byte count',
  '请输入旧固件版本': 'Enter old firmware version',
  '请输入正确的新固件型号': 'Enter a valid new firmware model',
  '请输入正确的新固件字节数': 'Enter a valid new firmware byte count',
  '请输入正确的新固件版本': 'Enter a valid new firmware version',
  '请输入正确的旧固件型号': 'Enter a valid old firmware model',
  '请输入正确的旧固件字节数': 'Enter a valid old firmware byte count',
  '请输入正确的旧固件版本': 'Enter a valid old firmware version',
  '请输入表编号': 'Please enter meter No.',
  '请选择使用状态': 'Please select usage status',
  '请选择升级包': 'Please select an upgrade package',
  '请选择升级状态': 'Select upgrade status',
  '请选择升级设备': 'Please select devices to upgrade',
  '请选择表口径': 'Please select meter caliber',
  '请选择表类型': 'Select meter type',
  '请选择设备': 'Please select device',
  '请选择运营商': 'Select carrier',
  '读/写命令返回信息成功': 'Read/Write Command Response Successful',
  '超声波水表': 'Ultrasonic Water Meter',
  '软件包名称': 'Software Package Name',
  '软件包版本': 'Software Package Version',
  '运营商': 'Carrier',
  '选择差分文件导入': 'Import difference file',
  '重置': 'Reset',
  '结算': 'Settlement',
  '考核': 'Assessment',
}
